import { ArrowUpRight } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "./Reveal";
import { PROJECTS } from "./data";

const onMove = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
};

const ProjectCard = ({ p, i }) => (
  <Reveal delay={(i % 3) * 0.1} className={`${p.span}`}>
    <article
      onMouseMove={onMove}
      data-testid={`project-card-${i}`}
      className="spotlight clip-corner group relative h-[340px] cursor-pointer overflow-hidden bg-[#12161F] md:h-full md:min-h-[300px]"
    >
      <img src={p.img} alt={p.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover grayscale transition-[transform,filter] duration-[1200ms] ease-out group-hover:scale-105 group-hover:grayscale-0" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
      <div className="spotlight-glow absolute inset-0" />
      <div className="absolute left-5 top-5 font-mono text-[11px] uppercase tracking-[0.2em] text-white">
        <span className="bg-blue-700 px-2 py-1 text-white">{p.type}</span>
      </div>
      <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between gap-4 p-6">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300">{p.spec} · {p.loc}</p>
          <h3 className="mt-2 font-display text-3xl font-bold uppercase leading-none text-white sm:text-4xl">{p.title}</h3>
        </div>
        <span className="grid h-12 w-12 shrink-0 place-items-center border border-white/30 text-white transition-[background-color,transform] duration-500 group-hover:rotate-45 group-hover:bg-blue-700 group-hover:text-white">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </div>
    </article>
  </Reveal>
);

export const Projects = () => (
  <section id="projects" data-testid="projects-section" className="bg-[#0D1015] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <div className="mb-14 grid gap-6 lg:grid-cols-2 lg:items-end">
        <div>
          <Eyebrow>Featured work</Eyebrow>
          <h2 className="font-display text-5xl font-black uppercase leading-[0.9] text-white sm:text-6xl lg:text-7xl">
            <MaskLines inView lines={["Built to", <span key="l" className="text-blue-500">last.</span>]} />
          </h2>
        </div>
        <Reveal>
          <p className="max-w-md text-base leading-relaxed text-slate-300 lg:ml-auto sm:text-lg">
            A look at the kind of homes and commercial spaces we take from foundation to finish. Every project gets the same crew discipline.
          </p>
        </Reveal>
      </div>
      <div className="grid gap-4 md:auto-rows-[300px] md:grid-cols-12">
        {PROJECTS.map((p, i) => <ProjectCard key={p.title} p={p} i={i} />)}
      </div>
    </div>
  </section>
);
